import unleash, { unleashState } from '@/utils/unleash'

export default {
  computed: {
    // shared across every component — see unleashState in src/utils/unleash.js
    unleashUpdated() {
      return unleashState.updated
    },
  },
  methods: {
    isFlagEnabled(name) {
      return this.unleashUpdated >= 0 && unleash.isEnabled(name)
    },
    getFlagVariant(name) {
      return unleash.getVariant(name)
    },
  },
}
